// router.js
import { createRouter, createWebHistory } from 'vue-router';
import { mainBaseUrl } from './apis/appconst';

import DashboardScreen from './pages/DashboardScreen.vue';
import LoginScreen from './pages/LoginScreen.vue';
import RolesScreen from './pages/RolesScreen.vue';
import AdminProfileScreen from './pages/AdminProfileScreen.vue';
import UserScreen from './pages/UserScreen.vue';
import FeedbacksScreen from './pages/FeedbacksScreen.vue';
import StoriesScreen from './pages/StoriesScreen.vue';
import BlogsScreen from './pages/BlogsScreen.vue';
import CatScreen from './pages/CatScreen.vue';
import CreatorsScreen from './pages/CreatorsScreen.vue';
import LectureScreen from './pages/LectureScreen.vue';
import ProjectsScreen from './pages/ProjectsScreen.vue';
import CourseFaqsScreen from './pages/CourseFaqsScreen.vue';
import CourseScreen from './pages/CourseScreen.vue';
import ModulesScreen from './pages/ModulesScreen.vue';
import ContentMainScreen from './pages/ContentMainScreen.vue';
import ContentTileScreen from './pages/ContentTileScreen.vue';
import EngagementScreen from './pages/EngagementScreen.vue';
import AdminSettingsScreen from './pages/AdminSettingsScreen.vue';
import CourseDetailsScreen from './pages/CourseDetailsScreen.vue';
import OrdersScreen from './pages/OrdersScreen.vue';
import LearningProgressScreen from './pages/LearningProgressScreen.vue';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: DashboardScreen
  },
  {
    path: '/login',
    name: 'LoginScreen',
    component: LoginScreen
  },
  
  {
    path: '/courses',
    name: 'CourseScreen',
    component: CourseScreen
  },
  {
    path: '/courses/:courseId',
    name: 'CourseDetailsScreen',
    component: CourseDetailsScreen,
  },
  {
    path: '/orders',
    name: 'OrdersScreen',
    component: OrdersScreen,
  },
  {
    path: '/learning-progress',
    name: 'LearningProgressScreen',
    component: LearningProgressScreen,
  },
  {
    path: '/modules',
    name: 'ModulesScreen',
    component: ModulesScreen
  },
  {
    path: '/lectures',
    name: 'LectureScreen',
    component: LectureScreen
  },
  {
    path: '/projects',
    name: 'ProjectsScreen',
    component: ProjectsScreen
  },
  {
    path: '/course-faqs',
    name: 'CourseFaqsScreen',
    component: CourseFaqsScreen
  },
  {
    path: '/roles',
    name: 'RolesScreen',
    component: RolesScreen
  },
  {
    path: '/admin-settings',
    name: 'AdminSettingsScreen',
    component: AdminSettingsScreen
  },
  {
    path: '/profile',
    name: 'AdminProfileScreen',
    component: AdminProfileScreen
  },
  {
    path: '/users',
    name: 'UserScreen',
    component: UserScreen
  },
  {
    path: '/feedback',
    name: 'FeedbacksScreen',
    component: FeedbacksScreen
  },
  {
    path: '/stories',
    name: 'StoriesScreen',
    component: StoriesScreen
  },
  {
    path: '/blogs',
    name: 'BlogsScreen',
    component: BlogsScreen
  },
  {
    path: '/categories',
    name: 'CatScreen',
    component: CatScreen
  },
  {
    path: '/creators',
    name: 'CreatorsScreen',
    component: CreatorsScreen
  },
  {
    path: '/content-main',
    name: 'ContentMainScreen',
    component: ContentMainScreen
  },
  {
    path: '/content-tiles',
    name: 'ContentTileScreen',
    component: ContentTileScreen
  },
  {
    path: '/course-bonuses',
    name: 'CourseBonusesScreen',
    component: ContentTileScreen,
    props: { bonusOnly: true }
  },
  {
    path: '/engagement',
    name: 'EngagementScreen',
    component: EngagementScreen
  }

];

const router = createRouter({
  history: createWebHistory(new URL(mainBaseUrl).pathname),
  routes
});

function hasValidAccessToken() {
  const token = sessionStorage.getItem('accessToken');

  if (!token) {
    return false;
  }

  try {
    const payload = JSON.parse(
      window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    );

    return !payload.exp || payload.exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
}

router.beforeEach((to, from, next) => {
  const ldataRaw = sessionStorage.getItem('ldata');
  const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
  const hasSession = Boolean(ldata && hasValidAccessToken());

  if (!to.path.includes("login") && !hasSession) {
    sessionStorage.removeItem('ldata');
    sessionStorage.removeItem('accessToken');
    return next('/login');
  }

  if (to.path.includes("login") && hasSession) {
    return next("/");
  }

  next();
});



export default router;
